import { render, staticRenderFns } from "./ProDetail.vue?vue&type=template&id=5f5a83d1&scoped=true"
import script from "./ProDetail.vue?vue&type=script&lang=js"
export * from "./ProDetail.vue?vue&type=script&lang=js"
import style0 from "./ProDetail.vue?vue&type=style&index=0&id=5f5a83d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a83d1",
  null
  
)

export default component.exports